import { call, put, all, takeLeading, delay } from 'redux-saga/effects';
import { getGeneralMessages } from '../generalMessages/slice';
import { getWorklistClaims } from '../worklistClaims/slice';
import { getWorklistRisks } from '../worklistRisks/slice';
import { getWorklistsItemCount, getWorklistsItemCountSucceeded, getWorklistsItemCountFailed } from './slice';
import { onGetWorklistsItemCount } from './api';

// To prevent more than one call every second. We get the count initial on app load,
// also some pages would get the count again, this prevents multiple calls in a short time span
const ITEM_COUNT_DELAY_MS = 1000;

function* getWorklistsItemCountWorker() {
  try {
    const response = yield call(onGetWorklistsItemCount);
    yield put(getWorklistsItemCountSucceeded(response.data));
  } catch {
    yield put(getWorklistsItemCountFailed());
  } finally {
    yield delay(ITEM_COUNT_DELAY_MS);
  }
}

export default function* worklistsSaga() {
  yield all([
    takeLeading(
      [getWorklistsItemCount.type, getGeneralMessages.type, getWorklistClaims.type, getWorklistRisks.type],
      getWorklistsItemCountWorker
    )
  ]);
}
